var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nuttrema-widget"},[_c('Timeline',{staticClass:"nuttrema-widget--twitter",attrs:{"id":"dietcreator","sourceType":'profile',"options":{ tweetLimit: '3' }}},[_c('nuttrema-loader')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15fa0af5","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/widgets/widget-twitter-latest.vue
// module id = 2943
// module chunks = 0